import React from 'react';
import ButtonLink from 'lib/control/ButtonLink';
import styles from './Tabs.less';

class Tabs extends React.Component {
	constructor(props) {
		super();
		const {selected_tab_idx = 0} = props;
		this.state = {
			selected_tab_idx
		};
	}

	componentDidUpdate() {
		const {selected_tab_idx} = this.props;
		const current_selected_tab_idx = this.state.selected_tab_idx;

		if (selected_tab_idx !== undefined && selected_tab_idx !== current_selected_tab_idx) {
			this.changeSelectedTab(selected_tab_idx)
		}
	}

	changeSelectedTab(new_idx) {
		this.setState({
			selected_tab_idx: new_idx
		});

		if (this.props.changeParentState) {
			this.props.changeParentState('selected_tab_idx', new_idx)
		}
	}

	render() {
		const {tabs, onTabAdd, changeParentState, ...props} = this.props;
		const {
			tabs: tabsClass,
			tab: tabClass,
			tab_active: activeTabClass,
			tab__btn: tabBtnClass,
			content: contentClass,
			'tab__add-icon': tabAddClass,
		} = styles;

		if (tabs.length === 0 && !onTabAdd) {
			return null;
		}

		const {selected_tab_idx} = this.state;

		if (tabs.length > 0 && !tabs[selected_tab_idx]) {
			let idx = selected_tab_idx ;

			while (!tabs[idx] && idx > 0) {
				idx--;
			}

			this.changeSelectedTab(idx);
		}

		const selected_tab = tabs[selected_tab_idx] || {label: '', content: ''};

		return (
			<div>
				{window.shop_ui_version === '2.0' ? (
					<div className="tab custom-pb-32">
						<ul className="tabs custom-mb-24">
							{tabs.map((tab, idx) => (
								<li key={idx} className={selected_tab_idx === idx ? 'selected' : ''} onClick={() => this.changeSelectedTab(idx)}>
									<a className="pointer">{tab.label}</a>
								</li>
							))}

							{onTabAdd && (
								<li>
									<a className="pointer" onClick={onTabAdd}>
										<i className={'fas fa-plus-circle ' + tabAddClass} />
									</a>
								</li>
							)}
						</ul>
						<div className="tab-content">
							<div>
								{selected_tab.content}
							</div>
						</div>
					</div>
				) : (
					<div {...props}>
						<div className={tabsClass}>
							{tabs.map((tab, idx) => (
								<div key={idx}
									 className={selected_tab_idx === idx ? [tabClass, activeTabClass].join(' ') : tabClass}
									 onClick={() => this.changeSelectedTab(idx)}>
									<ButtonLink className={tabBtnClass}>{tab.label}</ButtonLink>
								</div>
							))}

							{onTabAdd ? (
								<div className={tabClass}>
									<ButtonLink className={tabBtnClass} onClick={onTabAdd}>
										<i className={'icon16 plus ' + tabAddClass} />
									</ButtonLink>
								</div>
							) : null}
						</div>
						<div className={contentClass}>
							{selected_tab.content}
						</div>
					</div>
				)}
			</div>
		);
	}
}

export default Tabs;